<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="scss">
    @import './scss/bootstrap';
    @import './scss/style';
    @import './scss/animate';
    @import './scss/all-themes';
    @import './scss/materialize';
</style>

<style>
    $fa-font-path: '~font-awesome/fonts/';
    @import '~font-awesome/css/font-awesome.min.css';
</style>


// WEBPACK FOOTER //
// src/App.vue?532b71a0